import {State} from '../types/state'

export const getStaticMapUrl = (state: State) => state.staticMapUrl
